const scrollTo = ($element, offset = 0, duration = 1000) => {
  $([document.documentElement, document.body]).animate({
    scrollTop: $element.offset().top - offset,
    easing: 'linear',
  }, duration);
};

export default scrollTo;
